import React, { useState } from 'react';
import { FileText, ExternalLink, ChevronDown, ChevronUp, Search } from 'lucide-react';
import './ChatComponents.css';

/**
 * Documentation search results with expandable snippets
 */
function DocSnippets({ title, data, actions, onAction }) {
  const [expandedIdx, setExpandedIdx] = useState(null);

  const toggleExpand = (idx) => {
    setExpandedIdx(prev => prev === idx ? null : idx);
  };

  const handleOpenUrl = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener');
    }
  };

  const handleRelatedQuery = (snippet) => {
    if (onAction) {
      onAction({
        type: 'query',
        query: `Tell me more about ${snippet.section || snippet.document}`,
      });
    }
  };

  const getRelevanceColor = (relevance) => {
    const score = parseFloat(relevance);
    if (score >= 0.7) return 'var(--color-success)';
    if (score >= 0.4) return 'var(--color-warning)';
    return 'var(--color-text-muted)';
  };

  return (
    <div className="cc-doc-snippets">
      {title && <div className="cc-section-title">{title}</div>}

      <div className="cc-snippets-list">
        {data.snippets?.map((snippet, idx) => (
          <div key={idx} className="cc-snippet">
            {/* Header */}
            <div
              className="cc-snippet-header"
              onClick={() => toggleExpand(idx)}
            >
              <FileText size={14} color="var(--color-primary)" />
              <div className="cc-snippet-meta">
                <span className="cc-snippet-doc">{snippet.document}</span>
                {snippet.section && (
                  <span className="cc-snippet-section">{snippet.section}</span>
                )}
                {snippet.docType && (
                  <span className="cc-doc-type">{snippet.docType}</span>
                )}
              </div>
              <span
                className="cc-relevance"
                style={{ color: getRelevanceColor(snippet.relevance) }}
              >
                {(parseFloat(snippet.relevance) * 100).toFixed(0)}% match
              </span>
              {expandedIdx === idx ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            </div>

            {/* Preview (always shown) */}
            <div className="cc-snippet-preview">
              {snippet.content?.substring(0, 150)}...
            </div>

            {/* Expanded content */}
            {expandedIdx === idx && (
              <div className="cc-snippet-expanded">
                <div className="cc-snippet-full">
                  {snippet.content}
                </div>
                <div className="cc-snippet-actions">
                  {snippet.url && (
                    <button
                      className="cc-snippet-action"
                      onClick={() => handleOpenUrl(snippet.url)}
                    >
                      <ExternalLink size={12} />
                      View full document
                    </button>
                  )}
                  <button
                    className="cc-snippet-action"
                    onClick={() => handleRelatedQuery(snippet)}
                  >
                    <Search size={12} />
                    Related topics
                  </button>
                </div>
                {snippet.page && (
                  <span className="cc-page-ref">Page {snippet.page}</span>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {data.snippets?.length === 0 && (
        <div className="cc-no-results">
          No documentation found for this query.
        </div>
      )}
    </div>
  );
}

export default DocSnippets;
